import React from 'react';

const Footer = () => {
  return (
    <footer className="py-12 bg-white/90 backdrop-blur-md border-t border-gray-200">
      <div className="container mx-auto px-4 text-center text-sm text-gray-700 font-outfit">
        <p className="font-playfair mb-2 text-base text-wedding-burgundy">Victoria & Sanro</p>
        <p className="text-sm">14 de febrero de 2026 · Madrid</p>
      </div>
    </footer>
  );
};

export default Footer;
